module.exports = __webpack_public_path__ + "img/case26.c446d0ce.png";